// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';
import { MrWithTooltip, MrText, MrToggleText } from '@ion/components';
import BaseTable from '../../base-table/BaseTable';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import FeatureGate from 'app/launch-darkly/gates/feature-gate';

const SWITCH_OPTIONS = {
  option1: { name: 'OFF', value: 'false' },
  option2: { name: 'ON', value: 'true' },
};

const TOOLTIP_MESSAGE =
  'Your CMP must be configured to support IAB TCF and expose __tcfapi. Enabling this setting without a properly configured CMP may result in loss of data. If the vendor is missing from the IAB global vendor list or the TCF API is not responding, the selected consent type category will be used.';

const TcfConsentTable = ({
  formState,
  setField,
  validateRequired,
  validateField,
  syncName,
  title = 'IAB TCF Consent',
  prefix = 'sync',
}) => {
  const tcfEnabledSelectName = `${prefix}-${syncName}-tcfEnabled`;
  const isExplicitConsent = Boolean(formState.impliedConsent && formState.impliedConsent.value === 'false');

  return (
    <FeatureGate flagName={FEATURE_FLAGS.ecmIabTcfConsent}>
      <BaseTable styleNames="noBorders">
        <tbody>
          <tr key={'consent-type'}>
            <td>
              <MrWithTooltip message={TOOLTIP_MESSAGE}>
                <MrText styleNames="bold" component="span" required={Boolean(validateRequired && validateField)}>
                  {title}
                </MrText>
              </MrWithTooltip>
            </td>
            <td>
              {isExplicitConsent ? (
                <MrToggleText
                  name={tcfEnabledSelectName}
                  validators={validateRequired ? [validateRequired()] : undefined}
                  testId={tcfEnabledSelectName}
                  value={formState[tcfEnabledSelectName]?.value || 'false'}
                  options={SWITCH_OPTIONS}
                  onChange={setField}
                />
              ) : (
                <MrText component="p" styleNames="smallGray" testId={tcfEnabledSelectName}>
                  Disabled, set the Consent Policy to Explicit Consent to enable.
                </MrText>
              )}
            </td>
          </tr>
        </tbody>
      </BaseTable>
    </FeatureGate>
  );
};

TcfConsentTable.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  validateField: pt.func.isRequired,
  validateRequired: pt.func.isRequired,
  syncName: pt.string.isRequired,
  title: pt.string,
  prefix: pt.string,
};
export default TcfConsentTable;
